/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ShareSocial.css';
import { Link } from 'react-router';
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share';

const { FacebookShareButton, LinkedinShareButton } = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const LinkedinIcon = generateShareIcon('linkedin');

@withStyles(s)
export default class ShareSocial extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            url: this.props.urlProp,
        };

    }

    componentDidMount() {

        
    }

    render() {

        const shareUrl = this.state.url;
        const title = 'Titre';

        return (
            <div className={s.root}>
                <div className={`iconSocial`}>
                    <FacebookShareButton
                        url={shareUrl}
                        title={title}
                        className={`facebookShare`}>
                        <FacebookIcon size={32} round={false} />
                    </FacebookShareButton>
                </div>
                <div className={`iconSocial`}>
                    <LinkedinShareButton
                        url={shareUrl}
                        title={title}
                        className={`linkedinShare`}>
                        <LinkedinIcon size={32} round={false} />
                    </LinkedinShareButton>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/ShareSocial/ShareSocial.js